import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { Button, Stack } from '@mui/material'
import Multiselect from './components/Multiselect'
import Editor from 'components/editor'

const CreateModal = ({ handleRefresh, apps }) => {
  const uploadImage = useUploadImage()

  const [agency] = useAgencyInfo()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [selectedApp, setSelectedApp] = useState(null)
  const [description, setDescription] = useState('')

  const appOptions = apps?.map((item) => ({
    label: item?.name,
    value: item?.app_id,
  }))

  // console.log(svgIcon, "svgIcon")
  const handleModal = () => {
    setOpenAddProduct(true)
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)
    const app_type = ''
    let image_response
    image_response = await uploadImage({
      file: e.target?.image?.files?.[0],
      desiredPath: `app/logo/image`,
    })

    const payload = {
      name: e.target.name.value,
      description,
      website: e.target.website.value,
      video: e.target.video.value,
      image: image_response?.response.data,
      app: e.target.app.value,
      type: e.target.type.value,
    }

    console.log(payload, 'payload')

    const { response } = await AppService.partner.create({ payload })

    if (response) {
      setProcessing(false)
      closeAddProduct()
      handleRefresh()
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>
      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Section
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">App ID</MDTypography>
              <MDInput label="app_id" name="app" fullWidth />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Website</MDTypography>
              <MDInput label="website" name="website" fullWidth />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Video</MDTypography>
              <MDInput label="Video" name="video" fullWidth />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <MDInput
                select
                name="type"
                defaultValue=""
                fullWidth
                required
                SelectProps={{ native: true }}
              >
                <option value="" disabled>
                  Select a Type
                </option>
                <option value="Level 1">Level 1</option>
                <option value="Level 2">Level 2</option>
                <option value="Level 3">Level 3</option>
              </MDInput>
            </MDBox>

            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Add Logo
                <input hidden name="image" type="file" />
              </Button>
            </Stack>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
